<template>
  <transition name="slide-fade">
    <div class="toast" v-show="visible">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
      message: '', // 消息文字
      duration: 3000, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器
      visible: false // 是否显示
    }
  },
  mounted () {
    this.startTimer()
  },
  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false
        this.destroyElement()
      }
    }
  },
  methods: {
    destroyElement () {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    startTimer () {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true
          clearTimeout(this.timer)
        }
      }, this.duration)
    }
  }
}
</script>

<style>
.toast {
  position: fixed;
  top: 30%;
  left: 50%;
  min-width: 120px;
  max-width: 750px;
  /* font-size: 24px; */
  text-align: center;
  padding: 10px 20px;
  border-radius: .4rem;
  background-color: rgba(0, 0, 0 , 0.6);
  color: rgb(223, 219, 219);
  letter-spacing: 3px;
  transform: translate(-50%,-50%);
}

@media not all and (min-width:900px){
    .toast{
      padding: 10px 40px;
      font-size: 28px;
    }    
}
</style>


// WEBPACK FOOTER //
// src/components/Toast/Toast.vue